import { api } from '../../../api/index';
import { actions } from '../../../../store/actions/index';

export const adminCancelOrder = (id, getPageData) => async dispatch => {
  try {
    await api.adminCancelOrder(id);
    const response = await api.getOrders(getPageData());
    dispatch(actions.setOrders.act(response.data));
  } catch (e) {
    return e;
  }
};
